import type { LoaderFunctionArgs, MetaFunction } from "react-router";
import { redirect } from "react-router";
import { Form } from "react-router";
import { StudioScreenName } from "~/modules/studio";
import { login } from "../../shopify.server";
import "./style.css";
import { Label, TextInput } from "flowbite-react";
import loginImage from "../../assets/login.png";
import logo from "../../assets/logo.svg";
import { ReactivButton } from "~/components/atomics/Button";

const YEAR = new Date().getFullYear();

export const meta: MetaFunction = () => {
  return [
    { title: "Reactiv | Revolutionizing the way you shop ..." },
    { name: "description", content: "Revolutionizing the way you shop ..." },
    { property: "og:title", content: "Reactiv" },
    { property: "og:description", content: "Revolutionizing the way you shop" },
    {
      property: "og:image",
      content: "https://dashboard.reactivapp.com/og.jpg",
    },
    { property: "og:url", content: "https://dashboard.reactivapp.com" },
    { property: "og:type", content: "website" },
  ];
};

export async function loader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);

  if (url.searchParams.get("shop")) {
    throw redirect(
      `/app/studio/${StudioScreenName.Home}?${url.searchParams.toString()}`,
    );
  }

  return { showForm: Boolean(login) };
}

export default function App() {
  return (
    <section className="bg-white h-screen">
      <div className="grid lg:h-screen lg:grid-cols-2">
        <div className="flex flex-col items-center justify-between px-4 py-6 lg:py-0 sm:px-0">
          <div className="pt-16 pb-8 w-full max-w-md space-y-4 md:space-y-6 xl:max-w-xl">
            <a href="https://reactivapp.com">
              <img src={logo} alt="Reactiv" className="w-16 h-16" />
            </a>
          </div>
          <div className="flex flex-col items-center justify-center grow w-full max-w-md space-y-4 md:space-y-6 xl:max-w-xl">
            <Form
              method="post"
              action="/auth/login"
              className="w-full max-w-md space-y-4 md:space-y-6 xl:max-w-xl"
            >
              <h1 className="text-4xl font-bold text-gray-900 dark:text-white">
                Welcome
              </h1>
              <div>
                <Label htmlFor="email" className="mb-2 block">
                  Enter your Shop Domain
                </Label>
                <TextInput
                  type="text"
                  name="shop"
                  id="shop"
                  placeholder="my-shop-domain.myshopify.com"
                  sizing="lg"
                  required
                />
              </div>
              <ReactivButton
                variant="primary"
                type="submit"
                size="lg"
                className="w-full"
              >
                Sign In
              </ReactivButton>
              <p className="text-sm text-gray-500">
                Don't have an account?{" "}
                <a
                  href="https://www.shopify.com/ca/start"
                  className="font-medium text-black hover:underline"
                >
                  Sign Up
                </a>
              </p>
            </Form>
          </div>
          <div>
            <p className="text-center text-sm text-gray-500">
              &copy; {YEAR} Reactiv, LLC. All rights reserved.
            </p>
          </div>
        </div>
        <div
          className="items-center justify-center px-4 py-6 bg-primary-600 lg:py-0 sm:px-0 hidden lg:flex"
          style={{
            backgroundImage: `url(${loginImage})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top center",
          }}
        >
          <div className="sr-only">
            <h1 className="text-4xl font-bold text-white">Reactiv Dashboard</h1>
            <p className="text-lg text-white">
              Revolutionizing the way you shop ...
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
